/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_QuestionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if I only need the values from an old workbook?`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只需要旧工作簿里的数值怎么办？`)
};

/**
* | output |
* | --- |
* | "What if I only need the values from an old workbook?" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_question(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_question(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_question as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.3.question" }